var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top",style:(_vm.boxStyle)},_vm._l((_vm.topBarDatas),function(item,index){return _c('div',{key:index,class:{active:_vm.isClick == index},style:({
      ..._vm.divStyle,
      ..._vm.getStyle?.(item)
    }),on:{"click":function($event){return _vm.clickFn(item.fn,index)}}},[(_vm.iconShow)?_c('span',{style:({ backgroundImage: `url(${_vm.TopBarIcon})`, ..._vm.iconStyle, ..._vm.getIconStyle?.(item) })}):_vm._e(),_c('span',{style:(_vm.nameStyle)},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }